import * as React from 'react';
import useChartContext from './use_chart_context';
import propTypes from './prop_types';
var isServer = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var Chart = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    options,
    type = 'chart'
  } = _ref;
  var {
    create,
    theme
  } = useChartContext();
  if (isServer) {
    return null;
  }
  return create ? create(options, ref, theme, type) : /*#__PURE__*/React.createElement("div", null, "Missing Chart Provider");
});
Chart.propTypes = propTypes;
Chart.displayName = 'Chart';
export default Chart;